<template>
  <div class="wrapper">
    <p class="price">฿{{ price }}</p>
    <template v-if="hasDiscount">
      <p class="discount">฿{{ originalPrice }}</p>
      <span class="discount-percent">-{{ discountPercent }}%</span>
      <span class="no-coupon-needed">{{ t('noCouponNeeded') }}</span>
    </template>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  props: {
    // Price actually charged (already net of any product discount).
    price: {
      type: String,
      require: true,
    },
    // Struck-through list price, shown only while a discount is live.
    originalPrice: {
      type: String,
      default: '',
    },
    discountPercent: {
      type: [ Number, String ],
      default: 0,
    },
    discountActive: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { t } = useI18n()

    const hasDiscount = computed(() => (
      props.discountActive && Number(props.discountPercent) > 0 && !!props.originalPrice
    ))

    return { t, hasDiscount }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
}

.price {
  font-size: 1.3rem;
  font-weight: bold;
  color: #FD6868;
  @media screen and (min-width: 780px) {
    font-size: 1.4rem;
  }
}

.discount {
  font-size: 1.2rem;
  color: #C4C4C4;
  text-decoration: line-through;
  margin-left: 8px;
  @media screen and (min-width: 780px) {
    font-size: 1.3rem;
  }
}

.discount-percent {
  font-size: 1rem;
  font-weight: bold;
  color: #FD6868;
  border: 1px solid #FD6868;
  border-radius: 3px;
  padding: 1px 4px;
  margin-left: 8px;
  white-space: nowrap;
}

.no-coupon-needed {
  font-size: 1rem;
  color: #6A6A6A;
  border: 1px solid #D8D8D8;
  border-radius: 3px;
  padding: 1px 5px;
  margin-left: 8px;
  white-space: nowrap;
}
</style>
